import Link from 'next/link';
import Tooltip from '@components/Presentation/atoms/Tooltip';
import { HeadsetIcon, CertificateIcon, PaperPlaneTiltIcon } from '@phosphor-icons/react';
import Badge from '@atoms/Badge';

interface SidenavFooterProps {
  showProTrialButton: boolean;
  hasRequestedTrial: boolean;
  isRequestingTrial: boolean;
  isApprovedTrial: boolean;
  onRequestProTrial: () => void;
}

export default function SidenavFooter({
  showProTrialButton,
  hasRequestedTrial,
  isRequestingTrial,
  isApprovedTrial,
  onRequestProTrial
}: SidenavFooterProps) {
  return (
    <div className='px-6 mt-auto text-sm'>
      <div className='h-px bg-divider my-2 mx-2' />
      <div className='flex flex-col gap-1 mb-1'>
        {showProTrialButton && (
          hasRequestedTrial ? (
            <Tooltip
              isDisabled={isApprovedTrial}
              content="Your request has been sent. We'll get back to you soon." placement="top">
              <div className='rounded-md flex items-center px-2 py-1.5 h-7 gap-4 text-default-400 cursor-not-allowed opacity-60'>
                <div className='w-5 h-5 flex items-center'>
                  <PaperPlaneTiltIcon size={20} />
                </div>
                <span className='text-sm'>Get Pro trial</span>
                <span className='ml-auto text-sm'>2 weeks free</span>
              </div>
            </Tooltip>
          ) : (
            <div
              onClick={onRequestProTrial}
              className={`rounded-md flex items-center px-2 py-1.5 h-7 gap-4 text-default-700 hover:bg-content3 ${isRequestingTrial ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}
            >
              <div className='w-5 h-5 flex items-center'>
                <PaperPlaneTiltIcon size={20} />
              </div>
              <span className='text-sm font-normal'>Get Pro trial</span>
              <span className='ml-auto text-default-500 text-sm font-normal'>2 weeks free</span>
            </div>
          )
        )}
        <Link
          href='https://tidycal.com/team/streamalive/here-to-help'
          target='_blank'
          className='rounded-md flex items-center px-2 py-1.5 h-7 gap-4 text-default-700 hover:bg-content3'
        >
          <div className='w-fit h-5 flex items-center'>
            <HeadsetIcon size={20} />
          </div>
          <span className='text-sm'>Have questions?</span>
          <span className='ml-auto text-default-500 text-sm'>Book a call</span>
        </Link>
        <Link
          href='https://tidycal.com/team/streamalive/human-engagement-specialist'
          target='_blank'
          className='rounded-md flex items-center px-2 py-1.5 h-7 gap-4 text-default-700 hover:bg-content3'
        >
          <div className='w-5 h-5 flex items-center'>
            <CertificateIcon size={20} />
          </div>
          <span className='text-sm'>Get certified</span>
          <Badge className='ml-auto uppercase'>free</Badge>
        </Link>
      </div>
    </div>
  );
}
